'use client';

import React from 'react';

import styles from './styles.module.css';

import { AddToBagButton } from '@/app/[locale]/products/[slug]/components/AddToBagButton';
import { MakeOfferButton } from '@/app/[locale]/products/[slug]/components/MakeOfferButton';
import { MessageSellerButton } from '@/app/[locale]/products/[slug]/components/MessageSellerButton';
import { MobilePrice } from '@/app/[locale]/products/[slug]/components/Price/MobilePrice';
import { ON_IDENTIFIER } from '@/modules/experiments/config';
import { useExperiments } from '@/modules/experiments/useExperiments';
import { useProductBySlugExtendedPDP } from '@/modules/product/hooks/useProductBySlugExtendedPDP';
import { useFixedBottomPosition } from '@/utils/useFixedBottomPosition';

type Props = {
  hasMultipleSizes: boolean;
  selectedVariantId?: number;
  preventBuy: boolean;
  onMakeOfferClick?: (offerValue?: string) => void;
  showOfferSentContent?: boolean;
  showSellerFriction?: boolean;
};

function MobileProductActions({
  hasMultipleSizes,
  selectedVariantId,
  preventBuy,
  onMakeOfferClick = () => null,
  showOfferSentContent = false,
  showSellerFriction = false,
}: Props) {
  const { data: productExtended } = useProductBySlugExtendedPDP();

  const { ppx_399_buyer_actions_vacation_mode } = useExperiments([
    'ppx_399_buyer_actions_vacation_mode',
  ]);

  const isSellerOnVacation =
    ppx_399_buyer_actions_vacation_mode === ON_IDENTIFIER &&
    productExtended?.seller_activity?.is_on_vacation;

  const { bottomPos } = useFixedBottomPosition();

  return (
    <div
      className={styles.container}
      style={{
        bottom: `${bottomPos}px`,
      }}
    >
      <MobilePrice />
      {!isSellerOnVacation && (
        <div className={styles.mobileCtaGroup}>
          <MakeOfferButton
            className={styles.mobileCta}
            preventBuy={preventBuy}
            offerSent={showOfferSentContent}
            onClickAction={onMakeOfferClick}
            showForLoggedOutUsers
            size="regular"
          />
          {showSellerFriction ? (
            <MessageSellerButton
              className={styles.mobileCta}
              size="regular"
              isShortLabel
            />
          ) : (
            <AddToBagButton
              className={styles.mobileCta}
              preventBuy={preventBuy}
              hasMultipleSizes={hasMultipleSizes}
              selectedVariantId={selectedVariantId}
              size="regular"
              variant="primary"
            />
          )}
        </div>
      )}
    </div>
  );
}

export { MobileProductActions };
